@if (mode() === 'input-rob') {
  <input-inventory-rob (back)="onBack()" (save)="onSaveROB($event)"></input-inventory-rob>
} @else if (mode() === 'input-inventory') {
  <supply-details (back)="onBack()" (save)="onSaveSupplyDetails($event)"></supply-details>
} @else if (mode() === 'last-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_last_port' | transloco"
    (backEvent)="onBack()"
    (saveEvent)="onSavePort($event, 2)"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    [selected]="getControlByReportTypeId(portInformationForm, 2).value"
    (itemsChange)="appendVesselMovements($event)" />
} @else if (mode() === 'next-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_next_port' | transloco"
    (backEvent)="onBack()"
    (saveEvent)="onSavePort($event, 1)"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    [selected]="getControlByReportTypeId(portInformationForm, 1).value"
    (itemsChange)="appendVesselMovements($event)" />
} @else if (mode() === 'current-port-movements') {
  <lync-movement-selection
    [isDialog]="true"
    [title]="'ship_interface.select_current_port' | transloco"
    (saveEvent)="onSavePort($event, 38)"
    (backEvent)="onBack()"
    [queryParams]="{ 'filter[vessel_id]': profileState.profile()?.id }"
    [selected]="getControlByReportTypeId(portInformationForm, 38).value"
    (itemsChange)="appendVesselMovements($event)" />
} @else {
  <box [size]="sizeBox">
    <app-header [title]="title" [onClose]="onClose" [hasBottomBorder]="true"></app-header>
    <app-body class="py-0">
      @if (
        detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
        detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
        ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
      ) {
        <div class="pt-6">
          <step-progress class="w-full" [steps]="type() === 'sea' ? seaSteps() : portSteps()"></step-progress>
        </div>
      }
      @if (type() === 'sea') {
        @if (currentSeaStep() === 1) {
          <div
            class="border-b border-[#CBD7DF]"
            [ngClass]="
              detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                ? 'pb-6'
                : 'py-6'
            ">
            <subtitle-block [title]="'ship_interface.last_port_info' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(1)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.last_port' | transloco"
                class="w-full"
                [placeholder]="'ship_interface.select_last_port' | transloco"
                [readonly]="true"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                (click)="onPressLastPort()"
                [hintLabel]="
                  !isDifferentType && (!isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : '')
                "
                [hint]="!isDifferentType && getPreviousValueByReportTypeId(2) && getPreviousValueByReportTypeId(2)"
                [control]="getControlByReportTypeId(portInformationForm, 2)"></autofill>
              <textbox
                class="w-full"
                [label]="'ship_interface.distance_sailed_from_last_port' | transloco"
                [unit]="'ship_interface.nm' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 4)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="!isDifferentType && getPreviousValueByReportTypeId(4) | round: 2">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.distance_sailed_in_last_24_hours' | transloco"
                [unit]="'ship_interface.nm' | transloco"
                [placeholder]="'0.00'"
                [type]="'number'"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(portInformationForm, 5)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="!isDifferentType && getPreviousValueByReportTypeId(5) | round: 2">
              </textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.next_port_info' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(2)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <div class="flex w-full flex-row gap-2">
                <autofill
                  [label]="'ship_interface.next_port' | transloco"
                  class="w-full"
                  [placeholder]="'ship_interface.select_next_port' | transloco"
                  [readonly]="true"
                  [options]="vesselMovements()"
                  selectType="id"
                  displayName="port_name"
                  (click)="onPressNextPort()"
                  [control]="getControlByReportTypeId(portInformationForm, 1)"
                  [hintLabel]="
                    !isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''
                  "
                  [hint]="(!isDifferentType && getPreviousValueByReportTypeId(1)) || '-'">
                </autofill>
                <textbox
                  class="w-full"
                  [label]="'ship_interface.distance_left_to_next_port' | transloco"
                  [unit]="'ship_interface.nm' | transloco"
                  [placeholder]="'0.00'"
                  type="number"
                  [isDecimal]="true"
                  [decimal]="2"
                  [control]="getControlByReportTypeId(portInformationForm, 3)"
                  [hintLabel]="
                    !isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''
                  "
                  [hint]="!isDifferentType && getPreviousValueByReportTypeId(3) | round: 2"></textbox>
              </div>
              <form-date-picker
                class="w-full"
                [label]="'ship_interface.eta_next_port' | transloco"
                [hasCalendar]="true"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 6)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(6) | local: { format: 'DD MMM YYYY HH:mm' })) || '-'"></form-date-picker>
            </div>
          </div>
        } @else if (currentSeaStep() === 2) {
          <div
            class="border-b border-[#CBD7DF]"
            [ngClass]="
              detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                ? 'pb-6'
                : 'py-6'
            ">
            <subtitle-block [title]="'ship_interface.vessel_status' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(3)"></mat-icon>
              }
            </subtitle-block>
            <selection-button
              [label]="'ship_interface.is_the_vessel_currently_ballast_or_laden' | transloco"
              [buttons]="buttons()"
              (buttonsChange)="onButtonsChange($event)"
              type="single-selection"
              [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
              [hint]="
                !isDifferentType && getPreviousValueByReportTypeId(9) === 1
                  ? ('ship_interface.laden' | transloco)
                  : getPreviousValueByReportTypeId(9) === 0
                    ? ('ship_interface.ballast' | transloco)
                    : '-'
              ">
            </selection-button>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <lat-lon-input
                [label]="'ship_interface.longitude' | transloco"
                type="lon"
                class="w-full"
                [hasPadding]="false"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && decimalToDDM(getPreviousValueByReportTypeId(7), false)) || '-'"
                [control]="getControlByReportTypeId(vesselStatsForm, 7)">
              </lat-lon-input>
              <lat-lon-input
                type="lat"
                class="w-full"
                [hasPadding]="false"
                [label]="'ship_interface.latitude' | transloco"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && decimalToDDM(getPreviousValueByReportTypeId(8), true)) || '-'"
                [control]="getControlByReportTypeId(vesselStatsForm, 8)">
              </lat-lon-input>
            </div>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.speed' | transloco"
                [unit]="'ship_interface.kn' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 14)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(14) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_fwd' | transloco"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 10)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(10) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_mid' | transloco"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 11)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(11) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.draft_aft' | transloco"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 12)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(12) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.engine_status' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(4)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <form-date-picker
                [type]="'time'"
                class="w-full"
                [label]="'ship_interface.main_engine_running_hour' | transloco"
                [placeholder]="'ship_interface.0000' | transloco"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(13)) || '-'"
                [control]="getControlByReportTypeId(vesselStatsForm, 13)">
              </form-date-picker>
              <textbox
                class="w-full"
                [label]="'ship_interface.main_engine_rpm' | transloco"
                [unit]="'ship_interface.rpm' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 16)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="!isDifferentType && getPreviousValueByReportTypeId(16) | round: 2"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.main_engine_load' | transloco"
                unit="%"
                placeholder="0.00"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 17)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(17) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.main_engine_slip' | transloco"
                unit="%"
                placeholder="0.00"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 15)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(15) | round: 2)) || '-'"></textbox>
            </div>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <dropdown
                [label]="'ship_interface.ge_qty' | transloco"
                [placeholder]="'ship_interface.select_geqty' | transloco"
                class="w-full"
                [options]="Quantities"
                displayName="value"
                selectType="value"
                [control]="getControlByReportTypeId(vesselStatsForm, 18)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(18)) || '-'"></dropdown>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_load' | transloco"
                [unit]="'ship_interface.kw' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(vesselStatsForm, 19)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(19) | round: 2)) || '-'"></textbox>
            </div>
          </div>
        } @else if (currentSeaStep() === 3) {
          @if (isFirstReport) {
            <div
              class="border-b border-[#CBD7DF]"
              [ngClass]="
                !(
                  detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
                  detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
                  ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                )
                  ? 'py-6'
                  : 'pb-6'
              ">
              <div class="gap-[5px] px-9 py-3">
                <div class="flex flex-row place-items-center gap-1 font-medium text-warn">
                  <svg class="-mt-1" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.6132 11.6095L8.43353 0.8915C7.91819 0.3695 7.08199 0.3695 6.56665 0.8915L0.386506 11.6095C-0.128835 12.131 -0.128835 12.9775 0.386506 13.5H14.6127C15.129 12.9775 15.129 12.131 14.6132 11.6095ZM6.93095 4.739C6.93095 4.3245 7.26266 3.989 7.67138 3.989C8.0801 3.989 8.41181 4.3245 8.41181 4.739V8.239C8.41181 8.653 8.0801 8.989 7.67138 8.989C7.26266 8.989 6.93095 8.653 6.93095 8.239V4.739ZM7.67582 11.493C7.2671 11.493 6.93539 11.158 6.93539 10.743C6.93539 10.329 7.2671 9.993 7.67582 9.993C8.08454 9.993 8.41625 10.329 8.41625 10.743C8.41625 11.158 8.08454 11.493 7.67582 11.493Z"
                      fill="#FF0004" />
                  </svg>
                  <span>{{ 'ship_interface.you_are_adding_the_first_noon_report' | transloco }}</span>
                </div>
                <div class="font-medium">
                  {{ 'ship_interface.for_the_first_noon_report_only_bunker_lube_oil_fresh_water_rob_must_be_entered' | transloco }}
                  <span class="cursor-default" [ngClass]="{ 'cursor-pointer': isFirstReport }" (click)="onClickROB()">
                    <a>
                      <mat-icon class="relative top-[4px] mx-[4px]">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.625 2.8125C5.32663 2.8125 5.04048 2.93103 4.8295 3.142C4.61853 3.35298 4.5 3.63913 4.5 3.9375V14.0625C4.5 14.3609 4.61853 14.647 4.8295 14.858C5.04048 15.069 5.32663 15.1875 5.625 15.1875H10.125C10.4234 15.1875 10.7095 15.069 10.9205 14.858C11.1315 14.647 11.25 14.3609 11.25 14.0625V11.25C11.25 11.1008 11.3093 10.9577 11.4148 10.8523C11.5202 10.7468 11.6633 10.6875 11.8125 10.6875C11.9617 10.6875 12.1048 10.7468 12.2102 10.8523C12.3157 10.9577 12.375 11.1008 12.375 11.25V14.0625C12.375 14.6592 12.1379 15.2315 11.716 15.6535C11.294 16.0754 10.7217 16.3125 10.125 16.3125H5.625C5.02826 16.3125 4.45597 16.0754 4.03401 15.6535C3.61205 15.2315 3.375 14.6592 3.375 14.0625V3.9375C3.375 3.34076 3.61205 2.76847 4.03401 2.34651C4.45597 1.92455 5.02826 1.6875 5.625 1.6875H10.125C10.7217 1.6875 11.294 1.92455 11.716 2.34651C12.1379 2.76847 12.375 3.34076 12.375 3.9375V6.75C12.375 6.89918 12.3157 7.04226 12.2102 7.14775C12.1048 7.25324 11.9617 7.3125 11.8125 7.3125C11.6633 7.3125 11.5202 7.25324 11.4148 7.14775C11.3093 7.04226 11.25 6.89918 11.25 6.75V3.9375C11.25 3.63913 11.1315 3.35298 10.9205 3.142C10.7095 2.93103 10.4234 2.8125 10.125 2.8125H5.625ZM13.665 6.3525C13.7705 6.24716 13.9134 6.18799 14.0625 6.18799C14.2116 6.18799 14.3545 6.24716 14.46 6.3525L16.71 8.6025C16.8153 8.70797 16.8745 8.85094 16.8745 9C16.8745 9.14906 16.8153 9.29203 16.71 9.3975L14.46 11.6475C14.4085 11.7028 14.3464 11.7471 14.2774 11.7778C14.2084 11.8086 14.1339 11.8251 14.0584 11.8264C13.9829 11.8278 13.9078 11.8139 13.8378 11.7856C13.7678 11.7573 13.7041 11.7152 13.6507 11.6618C13.5973 11.6084 13.5552 11.5447 13.5269 11.4747C13.4986 11.4047 13.4847 11.3296 13.4861 11.2541C13.4874 11.1786 13.5039 11.1041 13.5347 11.0351C13.5654 10.9661 13.6097 10.904 13.665 10.8525L14.955 9.5625H6.75C6.60082 9.5625 6.45774 9.50324 6.35225 9.39775C6.24676 9.29226 6.1875 9.14918 6.1875 9C6.1875 8.85082 6.24676 8.70774 6.35225 8.60225C6.45774 8.49676 6.60082 8.4375 6.75 8.4375H14.955L13.665 7.1475C13.5597 7.04203 13.5005 6.89906 13.5005 6.75C13.5005 6.60094 13.5597 6.45797 13.665 6.3525Z"
                            fill="#0048FF" />
                        </svg>
                      </mat-icon>
                    </a>
                    <span class="font-semibold text-primary underline">{{ 'ship_interface.click_here_to_enter' | transloco }}</span>
                  </span>
                </div>
              </div>
              @if (hasROB) {
                <div>
                  <subtitle-block [title]="'ship_interface.inventory_rob' | transloco"> </subtitle-block>
                  <div class="flex w-full flex-row gap-2 px-9 py-3">
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.hfo' | transloco"
                      [value]="(form.get('rob_hfo').value | round: 2) + ' MT'">
                    </data-field>
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.mgo' | transloco"
                      [value]="(form.get('rob_mgo').value | round: 2) + ' MT'">
                    </data-field>
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.me_cyl' | transloco"
                      [value]="(form.get('rob_luboil_me_cyl').value | round: 2) + 'L'">
                    </data-field>
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.me_sys' | transloco"
                      [value]="(form.get('rob_luboil_me_sys').value | round: 2) + 'L'">
                    </data-field>
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.ge_sys' | transloco"
                      [value]="(form.get('rob_luboil_ge_sys').value | round: 2) + ' L'">
                    </data-field>
                    <data-field
                      type="vertical"
                      class="w-full px-0 py-0"
                      [label]="'ship_interface.fw' | transloco"
                      [value]="(form.get('rob_freshwater').value | round: 2) + ' MT'">
                    </data-field>
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="border-b border-[#CBD7DF] py-6">
              <subtitle-block [title]="'ship_interface.supplied_inventory' | transloco">
                <div action class="flex cursor-pointer flex-row items-center" (click)="onPressSupplyInventory()">
                  <mat-icon class="ml-1 icon-size-4" [svgIcon]="'heroicons_outline:new-edit'" />
                  <p class="ml-1 font-bold text-primary">{{ 'ship_interface.click_here_to_enter_edit' | transloco }}</p>
                </div>
              </subtitle-block>
              <div class="flex w-full flex-row gap-2 px-9 py-3">
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.hfo' | transloco" [value]="(getSupplyById(1) | round: 2) + ' MT'">
                </data-field>
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.mgo' | transloco" [value]="(getSupplyById(2) | round: 2) + ' MT'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.me_cyl' | transloco"
                  [value]="(getSupplyById(3) | round: 2) + ' L'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.me_sys' | transloco"
                  [value]="(getSupplyById(4) | round: 2) + ' L'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.ge_sys' | transloco"
                  [value]="(getSupplyById(5) | round: 2) + ' L'">
                </data-field>
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.fw' | transloco" [value]="(getSupplyById(37) | round: 2) + ' MT'">
                </data-field>
              </div>
            </div>
          }
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.hfo_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(5)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_me' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 20)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(20) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_ge' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 21)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(21) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_blr' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 22)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(22) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.mgo_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(6)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_me' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 23)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(23) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_ge' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 24)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(24) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_blr' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 25)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(25) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(7)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 26)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(26) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 27)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(27) | round: 2)) || '-'">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 28)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(28) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.fresh_water_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(8)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_generated' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 29)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(29) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_consumed' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 30)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(30) | round: 2)) || '-'"></textbox>
            </div>
          </div>
        } @else if (currentSeaStep() === 4) {
          <div
            class="border-b border-[#CBD7DF]"
            [ngClass]="
              detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                ? 'pb-6'
                : 'py-6'
            ">
            <subtitle-block [title]="'ship_interface.wind' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(9)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.wind_relative_direction' | transloco"
                unit="°"
                placeholder="0.00"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(weatherForm, 31)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(31) | round: 2)) || '-'"></textbox>
              <dropdown
                class="w-full"
                [label]="'ship_interface.wind_direction' | transloco"
                [placeholder]="'ship_interface.select_wind_direction' | transloco"
                [options]="WindDirections"
                displayName="direction"
                selectType="direction"
                [control]="getControlByReportTypeId(weatherForm, 32)"
                [hintLabel]="
                  !isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' + ': ' : ''
                "
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(32)) || '-'"></dropdown>
              <dropdown
                [label]="'ship_interface.wind_bf_scale' | transloco"
                [placeholder]="'ship_interface.select_wind_bf_scale' | transloco"
                class="w-full"
                [options]="WindBFScales"
                displayName="value"
                selectType="value"
                [control]="getControlByReportTypeId(weatherForm, 33)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(33)) || '-'"></dropdown>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.wave_swell' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(10)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.wave_height' | transloco"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(weatherForm, 34)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(34) | round: 2)) || '-'"></textbox>
              <dropdown
                class="w-full"
                [label]="'ship_interface.wave_dss' | transloco"
                [placeholder]="'ship_interface.select_wave_dss' | transloco"
                [options]="WaveDSS"
                displayName="value"
                selectType="value"
                [control]="getControlByReportTypeId(weatherForm, 35)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(35)) || '-'"></dropdown>
              <textbox
                class="w-full"
                [label]="'ship_interface.swell_height' | transloco"
                [unit]="'ship_interface.m' | transloco"
                [placeholder]="'0.00'"
                [isDecimal]="true"
                [decimal]="2"
                type="number"
                [control]="getControlByReportTypeId(weatherForm, 37)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(37)) || '-'"></textbox>
              <dropdown
                [label]="'ship_interface.swell_direction' | transloco"
                [placeholder]="'ship_interface.select_swell_direction' | transloco"
                class="w-full"
                [options]="SwellDirections"
                displayName="direction"
                selectType="direction"
                [control]="getControlByReportTypeId(weatherForm, 36)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(36)) || '-'"></dropdown>
            </div>
          </div>
        } @else {
          <div class="py-6">
            <pdf-subtitle-block
              [title]="(isSubmitStatus() ? 'ship_interface.noon_report' : 'ship_interface.review_noon_report') | transloco"
              titleClass="font-extrabold text-lg"></pdf-subtitle-block>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.port_information' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(1)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.last_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.last_port' | transloco" [value]="getDetailValueByReportTypeId(2)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.distance_from_last_port' | transloco"
                    [value]="(getDetailValueByReportTypeId(4) | round: 2) + ' NM'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.distance_in_last_24h' | transloco"
                    [value]="(getDetailValueByReportTypeId(5) | round: 2) + ' NM'"></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.next_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.next_port' | transloco" [value]="getDetailValueByReportTypeId(1)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.distance_left_to_next_port' | transloco"
                    [value]="(getDetailValueByReportTypeId(3) | round: 2) + ' NM'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.eta' | transloco"
                    [value]="getDetailValueByReportTypeId(6) | local: { format: 'DD MMM YYYY HH:mm' }"></pdf-body-block>
                </div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.vessel_stats' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(2)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.vessel_status' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.position' | transloco"
                    [value]="
                      decimalToDDM(getDetailValueByReportTypeId(7), false) + ', ' + decimalToDDM(getDetailValueByReportTypeId(8), true)
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.ballast_laden' | transloco"
                    [value]="(getDetailValueByReportTypeId(9) === 1 ? 'ship_interface.laden' : 'ship_interface.ballast') | transloco"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.speed' | transloco"
                    [value]="(getDetailValueByReportTypeId(14) | round: 2) + ' NM'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.draft_fwd_mid_aft' | transloco"
                    [value]="
                      (getDetailValueByReportTypeId(10) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(11) | round: 2) +
                      ' M' +
                      ' | ' +
                      (getDetailValueByReportTypeId(12) | round: 2) +
                      ' M'
                    "></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.engine_status' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine_running_hours' | transloco"
                    [value]="getDetailValueByReportTypeId(13)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine_rpm_load' | transloco"
                    [value]="
                      (getDetailValueByReportTypeId(16) | round: 2) + ' RPM' + ' | ' + (getDetailValueByReportTypeId(17) | round: 2) + ' %'
                    "></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine_slip' | transloco"
                    [value]="(getDetailValueByReportTypeId(15) | round: 2) + ' %'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.generator_quantity_load' | transloco"
                    [value]="(getDetailValueByReportTypeId(19) | round: 2) + ' KW' + ' | ' + getDetailValueByReportTypeId(18)"></pdf-body-block>
                </div>
              </div>
            </div>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.rob_consumption' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(3)"></pdf-subtitle-block>
              <div class="gap-3">
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.rob_summary' | transloco"></pdf-subtitle-block>
                    <div class="flex w-full flex-row gap-2 px-13 py-3">
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.hfo' | transloco"
                        [value]="(detailBunker()?.rob_hfo ? (detailBunker()?.rob_hfo | round: 2) : '0') + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.mgo' | transloco"
                        [value]="(detailBunker()?.rob_mgo ? (detailBunker()?.rob_mgo | round: 2) : '0') + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_cyl' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_cyl ? (detailBunker()?.rob_luboil_me_cyl | round: 2) : '0') + ' MT'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.me_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_me_sys ? (detailBunker()?.rob_luboil_me_sys | round: 2) : '0') + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.ge_sys' | transloco"
                        [value]="(detailBunker()?.rob_luboil_ge_sys ? (detailBunker()?.rob_luboil_ge_sys | round: 2) : '0') + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                      <data-field
                        type="vertical"
                        [label]="'ship_interface.fw' | transloco"
                        [value]="(detailBunker()?.rob_freshwater ? (detailBunker()?.rob_freshwater | round: 2) : '0') + ' L'"
                        class="w-full px-0 py-0">
                      </data-field>
                    </div>
                  </div>
                </div>
                <div class="flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.heavy_fuel_oil_vlsfo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(20) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(21) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(22) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.marine_gas_oil_lsmgo' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(23) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine' | transloco"
                      [value]="(getDetailValueByReportTypeId(24) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.boiler_room' | transloco"
                      [value]="(getDetailValueByReportTypeId(25) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
                <div class="mt-3 flex w-full flex-row">
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.lubricant_oil' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_cyliner' | transloco"
                      [value]="(getDetailValueByReportTypeId(26) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.main_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(27) | round: 2) + ' L'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generator_engine_system' | transloco"
                      [value]="(getDetailValueByReportTypeId(28) | round: 2) + ' L'"></pdf-body-block>
                  </div>
                  <div class="w-full">
                    <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.fresh_water' | transloco"></pdf-subtitle-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.generated' | transloco"
                      [value]="(getDetailValueByReportTypeId(29) | round: 2) + ' MT'"></pdf-body-block>
                    <pdf-body-block
                      type="short-body"
                      [label]="'ship_interface.consumption' | transloco"
                      [value]="(getDetailValueByReportTypeId(30) | round: 2) + ' MT'"></pdf-body-block>
                  </div>
                </div>
              </div>
            </div>
            @if (!isEmpty(detailNoonReport()?.supplies)) {
              <div class="py-3">
                <div class="w-full">
                  <pdf-subtitle-block
                    type="short-subtitle"
                    [title]="'ship_interface.inventory_supply' | transloco"
                    [hasEdit]="!isSubmitStatus()"
                    editButtonTitle=""
                    [underline]="!!isSubmitStatus()"
                    (edit)="onPressInventorySection(3)"></pdf-subtitle-block>
                  <div class="flex w-full flex-row gap-2 px-13 py-[10px]">
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.hfo' | transloco"
                      [value]="(getSupplyById(1) | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.mgo' | transloco"
                      [value]="(getSupplyById(2) | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_cyl' | transloco"
                      [value]="(getSupplyById(3) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_sys' | transloco"
                      [value]="(getSupplyById(4) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.ge_sys' | transloco"
                      [value]="(getSupplyById(5) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.fw' | transloco"
                      [value]="(getSupplyById(37) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                  </div>
                </div>
              </div>
            }
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.weather' | transloco"
                [hasEdit]="!isSubmitStatus()"
                editButtonTitle=""
                [underline]="!!isSubmitStatus()"
                (edit)="onPressSection(4)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.wind' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.relative_direction' | transloco"
                    [value]="getDetailValueByReportTypeId(31) + ' °'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.direction' | transloco"
                    [value]="getDetailValueByReportTypeId(32)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.force_bf_scale' | transloco"
                    [value]="getDetailValueByReportTypeId(33)"></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.wave_swell' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.wave_height' | transloco"
                    [value]="(getDetailValueByReportTypeId(34) | round: 2) + ' M'"></pdf-body-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.wave_dss' | transloco" [value]="getDetailValueByReportTypeId(35)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.swell_height' | transloco"
                    [value]="(getDetailValueByReportTypeId(37) | round: 2) + ' M'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.swell_direction' | transloco"
                    [value]="getDetailValueByReportTypeId(36)"></pdf-body-block>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {
        @if (currentPortStep() === 1) {
          <div
            class="border-b border-[#CBD7DF]"
            [ngClass]="
              detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
              detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
              ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                ? 'pb-6'
                : 'py-6'
            ">
            <subtitle-block [title]="'ship_interface.current_port_info' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(1)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.current_port' | transloco"
                class="w-full"
                [placeholder]="'ship_interface.select_current_port' | transloco"
                [readonly]="true"
                (click)="onPressCurrentPort()"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                [control]="getControlByReportTypeId(portInformationForm, 38)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(38)) || '-'"></autofill>
              <form-date-picker
                class="w-full"
                [label]="'ship_interface.etd' | transloco"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 39)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="
                  !isDifferentType && getPreviousValueByReportTypeId(39) ? (getPreviousValueByReportTypeId(39) | local: { format: 'DD MMM YYYY HH:mm' }) : '-'
                "></form-date-picker>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.next_port_info' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(2)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row gap-2 px-9 py-3">
              <autofill
                [label]="'ship_interface.next_port' | transloco"
                class="w-full"
                [placeholder]="'ship_interface.select_next_port' | transloco"
                [readonly]="true"
                [options]="vesselMovements()"
                selectType="id"
                displayName="port_name"
                (click)="onPressNextPort()"
                [control]="getControlByReportTypeId(portInformationForm, 1)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && getPreviousValueByReportTypeId(1)) || '-'"></autofill>
              <form-date-picker
                class="w-full"
                [label]="'ship_interface.eta' | transloco"
                type="date-time"
                [control]="getControlByReportTypeId(portInformationForm, 6)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(6) | local: { format: 'DD MMM YYYY HH:mm' })) || '-'">
              </form-date-picker>
            </div>
          </div>
        } @else if (currentPortStep() === 2) {
          @if (isFirstReport) {
            <div
              class="border-b border-[#CBD7DF]"
              [ngClass]="
                !(
                  detailNoonReport().status_id !== REPORT_STATUS.SUBMITTED &&
                  detailNoonReport().status_id !== REPORT_STATUS.SAVED &&
                  ((type() === 'sea' && currentSeaStep() !== 5) || (type() === 'port' && currentPortStep() !== 3))
                )
                  ? 'py-6'
                  : 'pb-6'
              ">
              <div class="gap-[5px] px-9 py-3">
                <div class="flex flex-row place-items-center gap-1 font-medium text-warn">
                  <svg class="-mt-1" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.6132 11.6095L8.43353 0.8915C7.91819 0.3695 7.08199 0.3695 6.56665 0.8915L0.386506 11.6095C-0.128835 12.131 -0.128835 12.9775 0.386506 13.5H14.6127C15.129 12.9775 15.129 12.131 14.6132 11.6095ZM6.93095 4.739C6.93095 4.3245 7.26266 3.989 7.67138 3.989C8.0801 3.989 8.41181 4.3245 8.41181 4.739V8.239C8.41181 8.653 8.0801 8.989 7.67138 8.989C7.26266 8.989 6.93095 8.653 6.93095 8.239V4.739ZM7.67582 11.493C7.2671 11.493 6.93539 11.158 6.93539 10.743C6.93539 10.329 7.2671 9.993 7.67582 9.993C8.08454 9.993 8.41625 10.329 8.41625 10.743C8.41625 11.158 8.08454 11.493 7.67582 11.493Z"
                      fill="#FF0004" />
                  </svg>
                  <span>{{ 'ship_interface.you_are_adding_the_first_noon_report' | transloco }}</span>
                </div>
                <div class="font-medium">
                  {{ 'ship_interface.for_the_first_noon_report_only_bunker_lube_oil_fresh_water_rob_must_be_entered' | transloco }}
                  <span class="cursor-default" [ngClass]="{ 'cursor-pointer': isFirstReport }" (click)="onClickROB()">
                    <a>
                      <mat-icon class="relative top-[4px] mx-[4px]">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.625 2.8125C5.32663 2.8125 5.04048 2.93103 4.8295 3.142C4.61853 3.35298 4.5 3.63913 4.5 3.9375V14.0625C4.5 14.3609 4.61853 14.647 4.8295 14.858C5.04048 15.069 5.32663 15.1875 5.625 15.1875H10.125C10.4234 15.1875 10.7095 15.069 10.9205 14.858C11.1315 14.647 11.25 14.3609 11.25 14.0625V11.25C11.25 11.1008 11.3093 10.9577 11.4148 10.8523C11.5202 10.7468 11.6633 10.6875 11.8125 10.6875C11.9617 10.6875 12.1048 10.7468 12.2102 10.8523C12.3157 10.9577 12.375 11.1008 12.375 11.25V14.0625C12.375 14.6592 12.1379 15.2315 11.716 15.6535C11.294 16.0754 10.7217 16.3125 10.125 16.3125H5.625C5.02826 16.3125 4.45597 16.0754 4.03401 15.6535C3.61205 15.2315 3.375 14.6592 3.375 14.0625V3.9375C3.375 3.34076 3.61205 2.76847 4.03401 2.34651C4.45597 1.92455 5.02826 1.6875 5.625 1.6875H10.125C10.7217 1.6875 11.294 1.92455 11.716 2.34651C12.1379 2.76847 12.375 3.34076 12.375 3.9375V6.75C12.375 6.89918 12.3157 7.04226 12.2102 7.14775C12.1048 7.25324 11.9617 7.3125 11.8125 7.3125C11.6633 7.3125 11.5202 7.25324 11.4148 7.14775C11.3093 7.04226 11.25 6.89918 11.25 6.75V3.9375C11.25 3.63913 11.1315 3.35298 10.9205 3.142C10.7095 2.93103 10.4234 2.8125 10.125 2.8125H5.625ZM13.665 6.3525C13.7705 6.24716 13.9134 6.18799 14.0625 6.18799C14.2116 6.18799 14.3545 6.24716 14.46 6.3525L16.71 8.6025C16.8153 8.70797 16.8745 8.85094 16.8745 9C16.8745 9.14906 16.8153 9.29203 16.71 9.3975L14.46 11.6475C14.4085 11.7028 14.3464 11.7471 14.2774 11.7778C14.2084 11.8086 14.1339 11.8251 14.0584 11.8264C13.9829 11.8278 13.9078 11.8139 13.8378 11.7856C13.7678 11.7573 13.7041 11.7152 13.6507 11.6618C13.5973 11.6084 13.5552 11.5447 13.5269 11.4747C13.4986 11.4047 13.4847 11.3296 13.4861 11.2541C13.4874 11.1786 13.5039 11.1041 13.5347 11.0351C13.5654 10.9661 13.6097 10.904 13.665 10.8525L14.955 9.5625H6.75C6.60082 9.5625 6.45774 9.50324 6.35225 9.39775C6.24676 9.29226 6.1875 9.14918 6.1875 9C6.1875 8.85082 6.24676 8.70774 6.35225 8.60225C6.45774 8.49676 6.60082 8.4375 6.75 8.4375H14.955L13.665 7.1475C13.5597 7.04203 13.5005 6.89906 13.5005 6.75C13.5005 6.60094 13.5597 6.45797 13.665 6.3525Z"
                            fill="#0048FF" />
                        </svg>
                      </mat-icon>
                    </a>
                    <span class="font-semibold text-primary underline">{{ 'ship_interface.click_here_to_enter' | transloco }}</span>
                  </span>
                </div>
              </div>
              <div>
                <subtitle-block [title]="'ship_interface.inventory_rob' | transloco"> </subtitle-block>
                <div class="flex w-full flex-row gap-2 px-9 py-3">
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.hfo' | transloco"
                    [value]="(form.get('rob_hfo').value | round: 2) + ' MT'">
                  </data-field>
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.mgo' | transloco"
                    [value]="(form.get('rob_mgo').value | round: 2) + ' MT'">
                  </data-field>
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.me_cyl' | transloco"
                    [value]="(form.get('rob_luboil_me_cyl').value | round: 2) + 'L'">
                  </data-field>
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.me_sys' | transloco"
                    [value]="(form.get('rob_luboil_me_sys').value | round: 2) + 'L'">
                  </data-field>
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.ge_sys' | transloco"
                    [value]="(form.get('rob_luboil_ge_sys').value | round: 2) + ' L'">
                  </data-field>
                  <data-field
                    type="vertical"
                    class="w-full px-0 py-0"
                    [label]="'ship_interface.fw' | transloco"
                    [value]="(form.get('rob_freshwater').value | round: 2) + ' MT'">
                  </data-field>
                </div>
              </div>
            </div>
          } @else {
            <div class="border-b border-[#CBD7DF] py-6">
              <subtitle-block [title]="'ship_interface.supplied_inventory' | transloco">
                <div action class="flex cursor-pointer flex-row items-center" (click)="onPressSupplyInventory()">
                  <mat-icon class="ml-1 icon-size-4" [svgIcon]="'heroicons_outline:new-edit'" />
                  <p class="ml-1 font-bold text-primary">{{ 'ship_interface.click_here_to_enter_edit' | transloco }}</p>
                </div>
              </subtitle-block>
              <div class="flex w-full flex-row gap-2 px-9 py-3">
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.hfo' | transloco" [value]="(getSupplyById(1) | round: 2) + ' MT'">
                </data-field>
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.mgo' | transloco" [value]="(getSupplyById(2) | round: 2) + ' MT'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.me_cyl' | transloco"
                  [value]="(getSupplyById(3) | round: 2) + ' L'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.me_sys' | transloco"
                  [value]="(getSupplyById(4) | round: 2) + ' L'">
                </data-field>
                <data-field
                  type="vertical"
                  class="w-full px-0 py-0"
                  [label]="'ship_interface.ge_sys' | transloco"
                  [value]="(getSupplyById(5) | round: 2) + ' L'">
                </data-field>
                <data-field type="vertical" class="w-full px-0 py-0" [label]="'ship_interface.fw' | transloco" [value]="(getSupplyById(37) | round: 2) + ' MT'">
                </data-field>
              </div>
            </div>
          }
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.hfo_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(3)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_me' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 20)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(20) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_ge' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 21)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(21) | round: 2)) || '-'"
                a></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.hfo_blr' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 22)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(22) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.mgo_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(4)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_me' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 23)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(23) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_ge' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 24)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(24) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.mgo_blr' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 25)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(25) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="border-b border-[#CBD7DF] py-6">
            <subtitle-block [title]="'ship_interface.lube_oil_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(5)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.me_cyl' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 26)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(26) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.me_sys' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 27)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(27) | round: 2)) || '-'">
              </textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.ge_sys' | transloco"
                [unit]="'ship_interface.l' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 28)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(28) | round: 2)) || '-'"></textbox>
            </div>
          </div>
          <div class="py-6">
            <subtitle-block [title]="'ship_interface.fresh_water_consumption' | transloco">
              @if (!isDifferentType) {
                <mat-icon
                  action
                  class="ml-1 cursor-pointer icon-size-6"
                  [svgIcon]="'heroicons_outline:copy'"
                  [ngClass]="{ 'cursor-pointer text-primary': isEnableCopy() }"
                  (click)="isEnableCopy() && onPressCopy(6)"></mat-icon>
              }
            </subtitle-block>
            <div class="flex w-full flex-row items-center gap-2 px-9 py-3">
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_generated' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 29)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(29) | round: 2)) || '-'"></textbox>
              <textbox
                class="w-full"
                [label]="'ship_interface.fw_consumed' | transloco"
                [unit]="'ship_interface.mt' | transloco"
                [placeholder]="'0.00'"
                type="number"
                [isDecimal]="true"
                [decimal]="2"
                [control]="getControlByReportTypeId(consumptionForm, 30)"
                [hintLabel]="!isDifferentType && !isEmpty(previousNoonReport()) ? (previousNoonReport()?.date_report | local: { format: 'DD MMM' }) + ': ' : ''"
                [hint]="(!isDifferentType && (getPreviousValueByReportTypeId(30) | round: 2)) || '-'"></textbox>
            </div>
          </div>
        } @else {
          <div class="py-6">
            <pdf-subtitle-block
              [title]="(isSubmitStatus() ? 'ship_interface.noon_report' : 'ship_interface.review_noon_report') | transloco"
              titleClass="font-extrabold text-lg"></pdf-subtitle-block>
            <div class="py-3">
              <pdf-subtitle-block
                [title]="'ship_interface.port_information' | transloco"
                [hasEdit]="!isSubmitStatus()"
                [underline]="!!isSubmitStatus()"
                editButtonTitle=""
                (edit)="onPressSection(1)"></pdf-subtitle-block>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.current_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.current_port' | transloco"
                    [value]="getDetailValueByReportTypeId(38)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.etd' | transloco"
                    [value]="
                      getDetailValueByReportTypeId(39) ? (getDetailValueByReportTypeId(39) | local: { format: 'DD MMM YYYY HH:mm' }) : ''
                    "></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.next_port' | transloco"></pdf-subtitle-block>
                  <pdf-body-block type="short-body" [label]="'ship_interface.next_port' | transloco" [value]="getDetailValueByReportTypeId(1)"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.eta' | transloco"
                    [value]="getDetailValueByReportTypeId(6) | local: { format: 'DD MMM YYYY HH:mm' }"></pdf-body-block>
                </div>
              </div>
            </div>
            <pdf-subtitle-block
              [title]="'ship_interface.rob_consumption' | transloco"
              [hasEdit]="!isSubmitStatus()"
              editButtonTitle=""
              [underline]="!!isSubmitStatus()"
              (edit)="onPressSection(2)"></pdf-subtitle-block>
            <div class="gap-3">
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.rob_summary' | transloco"></pdf-subtitle-block>
                  <div class="flex w-full flex-row gap-2 px-13 py-3">
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.hfo' | transloco"
                      [value]="(detailBunker()?.rob_hfo | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.mgo' | transloco"
                      [value]="(detailBunker()?.rob_mgo | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_cyl' | transloco"
                      [value]="(detailBunker()?.rob_luboil_me_cyl | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_sys' | transloco"
                      [value]="(detailBunker()?.rob_luboil_me_sys | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.ge_sys' | transloco"
                      [value]="(detailBunker()?.rob_luboil_ge_sys | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.fw' | transloco"
                      [value]="(detailBunker()?.rob_freshwater | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                  </div>
                </div>
              </div>
              <div class="flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.heavy_fuel_oil_vlsfo' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine' | transloco"
                    [value]="(getDetailValueByReportTypeId(20) | round: 2) + ' MT'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.generator_engine' | transloco"
                    [value]="(getDetailValueByReportTypeId(21) | round: 2) + ' MT'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.boiler_room' | transloco"
                    [value]="(getDetailValueByReportTypeId(22) | round: 2) + ' MT'"></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.marine_gas_oil_lsmgo' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine' | transloco"
                    [value]="(getDetailValueByReportTypeId(23) | round: 2) + ' MT'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.generator_engine' | transloco"
                    [value]="(getDetailValueByReportTypeId(24) | round: 2) + ' MT'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.boiler_room' | transloco"
                    [value]="(getDetailValueByReportTypeId(25) | round: 2) + ' MT'"></pdf-body-block>
                </div>
              </div>
              <div class="mt-3 flex w-full flex-row">
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.lubricant_oil' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine_cyliner' | transloco"
                    [value]="(getDetailValueByReportTypeId(26) | round: 2) + ' L'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.main_engine_system' | transloco"
                    [value]="(getDetailValueByReportTypeId(27) | round: 2) + ' L'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.generator_engine_system' | transloco"
                    [value]="(getDetailValueByReportTypeId(28) | round: 2) + ' L'"></pdf-body-block>
                </div>
                <div class="w-full">
                  <pdf-subtitle-block type="short-subtitle" [title]="'ship_interface.fresh_water' | transloco"></pdf-subtitle-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.generated' | transloco"
                    [value]="(getDetailValueByReportTypeId(29) | round: 2) + ' MT'"></pdf-body-block>
                  <pdf-body-block
                    type="short-body"
                    [label]="'ship_interface.consumption' | transloco"
                    [value]="(getDetailValueByReportTypeId(30) | round: 2) + ' MT'"></pdf-body-block>
                </div>
              </div>
            </div>
            @if (!isEmpty(detailNoonReport()?.supplies)) {
              <div class="py-3">
                <div class="w-full">
                  <pdf-subtitle-block
                    type="short-subtitle"
                    [title]="'ship_interface.inventory_supply' | transloco"
                    [hasEdit]="!isSubmitStatus()"
                    editButtonTitle=""
                    [underline]="!!isSubmitStatus()"
                    (edit)="onPressInventorySection(2)"></pdf-subtitle-block>
                  <div class="flex w-full flex-row gap-2 px-13 py-[10px]">
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.hfo' | transloco"
                      [value]="(getSupplyById(1) | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.mgo' | transloco"
                      [value]="(getSupplyById(2) | round: 2) + ' MT'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_cyl' | transloco"
                      [value]="(getSupplyById(3) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.me_sys' | transloco"
                      [value]="(getSupplyById(4) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.ge_sys' | transloco"
                      [value]="(getSupplyById(5) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                    <data-field
                      type="vertical"
                      [label]="'ship_interface.fw' | transloco"
                      [value]="(getSupplyById(37) | round: 2) + ' L'"
                      class="w-full px-0 py-0">
                    </data-field>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      }
    </app-body>
    <app-footer
      [hasTopBorder]="true"
      [onDiscard]="onDiscard"
      [onSave]="onSave"
      [disabledSaveButton]="isDisableSaveButton()"
      [saveButtonClass]="detailNoonReport()?.status_id === 3 && 'bg-[#FAFAFA] text-[#FF0000]'"
      [saveButtonTitle]="saveTitle"></app-footer>
  </box>
}
